import Box from "@mui/material/Box";
import {CompanyProfileCard} from "../../Components/CompanyProfileCard/CompanyProfileCard";
import {FileDownloadBox} from "../../Components/Atoms/FileDownloadBox";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import placeholder from "../../images/zdjecie.png";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {getUrl} from "../../requests";
import {Modal} from "@mui/material";
import {InputListCard} from "../../Components/InputListCard/InputListCard";
import {SwitchListCard} from "../../Components/InputListCard/SwitchListCard";
import {withEditableServices} from "../withEditableServices";
import {withEditableClientTypes} from "../withEditableClientTypes";
import {withEditableCompanyInfo} from "../withEditableCompanyInfo";
import {withEditableInfo} from "../withEditableInfo";
import {withEditableMeetCompany} from "../withEditableMeetCompany";
import {useAuth0} from "@auth0/auth0-react";
import axios from "axios";
import clsx from "clsx";
import css from "./CompanyProfileCardsList.module.css";
import {CompanyMenu} from "./CompanyMenu";
import {OperationalContact, OperationalContactEdit, OperationalContactView} from "./OperationalContact";
import {CompanyProfileApla, InfoListItem} from "./CompanyProfileApla";

const CompanyProfileCardsList = (
    {
        downloadBox,
        profile,
        token,
        setopenInProgress,
        menuIx,
        profilerefs,
        setProfileRefs
    }
) => {

    console.log("CompanyProfileCardsList " ,     {
            downloadBox,
            profile,
            token,
            setopenInProgress,
            menuIx,
            profilerefs,
            setProfileRefs
        }
    );

    const rootRef = React.useRef < HTMLDivElement > (null);
    useEffect(() => {
        const myrefs = CompanyMenu.items.reduce((acc, value) => {
            acc[value.id] = React.createRef();
            return acc;
        }, []);
        setProfileRefs(myrefs);
    }, []);

    const [data, setData] = useState([]);
    const [telephones, setTelephones] = useState([
        {
            label: "Główny",
            value: "",
            name: "phone"
        },
        {
            label: "Ogólny",
            value: "",
            name: "phonePayments",
        },
        {
            label: "Serwisowy",
            value: data?.phoneService,
            name: "phoneService",
        }

    ]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [companyDiffInfo, setcompanyDiffInfo] = useState([]);

    const [bok, setBok] = useState([]);
    const [bokInfo, setBokInfo] = useState([]);
    const [bokSvcCust, setBokSvcCust] = useState([]);

    const [fiberInternetServicesList, setFiberInternetServicesList] = useState();
    const [wirelessInternetServicesList, setWirelessInternetServicesList] = useState();
    const [mobileInternetServicesList, setMobileInternetServicesList] = useState();
    const [tvServicesList, setTvServicesList] = useState();
    const [tvPacketsServicesList, setTvPacketsServicesList] = useState();

    const [telephonyServicesList, setTelephonyServicesList] = useState();
    const [otherServicesList, setOtherServicesList] = useState();
    const [mobileTelephonyServicesList, setMobileTelephonyServicesList] = useState();

    const [editServices, setEditServices] = useState(false);
    const [editClientTypes, setEditClientTypes] = useState(false);
    const [editCompanyInfo, setEditCompanyInfo] = useState(false);
    const [editCompanyGeneralInfo, setEditCompanyGeneralInfo] = useState(false);
    const [editVariousInfo, setEditVariousInfo] = useState(false);
    const [workingHoursState, setWorkingHoursState] = useState([]);
    const [editRangesNew, setEditRangesNew] = useState(false);
    const [editMeetCompany, setEditMeetCompany] = useState(false);

    const CANCEL_WARNING_MESSAGE = 'Anulujesz formularz edycji.\nJeżeli dane w formularzu były zmieniane nie zostaną zapisane w bazie.';

    const handleOpenEditMeetCompany = () => {
        setEditMeetCompany(true);
    }

    const handleOpenEditServices = (event) => {
        setEditServices(true);
    }


    const editMeetCompanyRef = useRef(null);
    const checkCloseEditMeetCompany = (event) => {
        console.log(event);
        if (editMeetCompanyRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditMeetCompany(false);
            }
        } else {
            setEditMeetCompany(false);
        }

    }
    const handleCloseEditMeetCompany = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseEditMeetCompany(event);
        }
    }
    const onKeyDownEditMeetCompany = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                editMeetCompanyRef.current?.save();
                break
            case 'Escape':
                checkCloseEditMeetCompany(event);
                break
            default:
                console.log('onKeyDownEditMeetCompany', event.key);
        }
    }

    const editServicesRef = useRef(null);
    const checkCloseEditServices = (event) => {
        console.log(event);
        if (editServicesRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditServices(false);
            }
        } else {
            setEditServices(false);
        }
    }
    const handleCloseEditServices = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseEditServices(event);
        }
    }
    const onKeyDownEditServices = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                editServicesRef.current?.save();
                event.stopPropagation();
                event.preventDefault();
                break;
            case 'Escape':
                checkCloseEditServices();
                break;
            default:
                console.log('onKeyDownEditServices', event.key);
        }
    }

    const closeClientTypesRef = useRef(null);
    const checkCloseClientTypes = (event) => {
        console.log(event);
        if (closeClientTypesRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditClientTypes(false);
            }
        } else {
            setEditClientTypes(false);
        }
    }
    const handleCloseClientTypes = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseClientTypes(event);
        }
    }
    const onKeyDownClientTypes = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                closeClientTypesRef.current?.save();
                break;
            case 'Escape':
                checkCloseClientTypes(event);
                break;
            default:
                console.log('onKeyDownClientTypes', event.key);
        }
    }

    const editCompanyInfoRef = useRef(null);
    const checkCloseEditCompanyInfo = (event) => {
        console.log(event);
        if (editCompanyInfoRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditCompanyInfo(false);
            }
        } else {
            setEditCompanyInfo(false);
        }
    }
    const handleCloseEditCompanyInfo = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseEditCompanyInfo(event);
        }
    }
    const onKeyDownEditCompanyInfo = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                editCompanyInfoRef.current?.save();
                break;
            case 'Escape':
                checkCloseEditCompanyInfo(event);
                break;
            default:
                console.log('onKeyDownEditCompanyInfo', event.key);
        }
    }

    const companyGeneralInfoRef = useRef(null);
    const checkCloseEditCompanyGeneralInfo = (event) => {
        console.log(event);
        if (companyGeneralInfoRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditCompanyGeneralInfo(false);
            }
        } else {
            setEditCompanyGeneralInfo(false);
        }
    }
    const handleCloseEditCompanyGeneralInfo = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseEditCompanyGeneralInfo();
        }
    }
    const onKeyDownEditCompanyGeneralInfo = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                companyGeneralInfoRef.current?.save();
                break;
            case 'Escape':
                checkCloseEditCompanyGeneralInfo();
                break;
            default:
                console.log('onKeyDownEditCompanyGeneralInfo', event.key);
        }
    }

    const closeEditVariousInfoRef = useRef(null);
    const checkCloseEditVariousInfo = (event) => {
        console.log(event);
        if (closeEditVariousInfoRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditVariousInfo(false);
            }
        } else {
            setEditVariousInfo(false);
        }
    }
    const handleCloseEditVariousInfo = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseEditVariousInfo(event);
        }
    };
    const onKeyDownEditVariousInfo = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                closeEditVariousInfoRef.current?.save();
                break;
            case 'Escape':
                checkCloseEditVariousInfo(event);
                break;
            default:
                console.log('onKeyDownEditVariousInfo', event.key);
        }

    };

    const editRangesNewRef = useRef(null);
    const checkCloseEditRangesNew = (event) => {
        console.log(event);
        if (editRangesNewRef.current?.isChanged()) {
            if (window.confirm(CANCEL_WARNING_MESSAGE)) {
                setEditRangesNew(false);
            }
        } else {
            setEditRangesNew(false);
        }
    }
    const handleCloseEditRangesNew = (event) => {
        if ("Anuluj" === event?.target?.innerText && "BUTTON" === event.target.nodeName) {
            checkCloseEditRangesNew(event);
        }
    }
    const onKeyDownEditRangesNew = (event) => {
        console.log(event.key, event.code);
        switch (event.key) {
            case 'Enter':
                editRangesNewRef.current?.save();
                break;
            case 'Escape':
                checkCloseEditRangesNew(event);
                break;
            default:
                console.log('onKeyDownEditRangesNew', event.key);
        }
    }

    const handleSavedEditMeetCompany = () => {
        setEditMeetCompany(false);
    }
    const handleSavedEditServices = () => {
        setEditServices(false);
    }
    const handleSavedEditClientTypes = () => {
        setEditClientTypes(false);
    }
    const handleSavedEditCompanyInfo = () => {
        setEditCompanyInfo(false);
    }
    const handleSavedEditCompanyGeneralInfo = () => {
        setEditCompanyGeneralInfo(false);
    }
    const handleSavedEditVariousInfo = () => {
        setEditVariousInfo(false);
    }
    const handleSavedEditRangesNew = () => {
        setEditRangesNew(false);
    }


    const {logout} = useAuth0();

    const setProfileVariables = (data) => {
        setData(data);
        setFiberInternetServicesList(
            data.products.filter(
                (product) => product.productCategory === "Internet światłowodowy"
            )
        );
        setMobileInternetServicesList(
            data.products.filter(
                (product) => product.productCategory === "Internet mobilny"
            )
        );
        setWirelessInternetServicesList(
            data.products.filter(
                (product) => product.productCategory === "Internet radiowy"
            )
        );
        setTvServicesList(
            data.products.filter(
                (product) => product.productCategory === "Telewizja"
            )
        );
        setTelephonyServicesList(
            data.products.filter(
                (product) => product.productCategory === "Telefonia"
            )
        );
        setOtherServicesList(
            data.products.filter((product) => product.productCategory === "Inne")
        );
        setMobileTelephonyServicesList(
            data.products.filter(
                (product) => product.productCategory === "Telefonia mobilna")
        );

        // setTvPacketsServicesList(
        //   data.products.filter((product) => product.productCategory === "Pakiety TV")
        // );


        setWorkingHoursState(
            data?.workingHours.map((el) =>
                el.weekDay === "Monday"
                    ? {
                        label: "Poniedziałek",
                        value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                    }
                    : el.weekDay === "Tuesday"
                        ? {
                            label: "Wtorek",
                            value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                        }
                        : el.weekDay === "Wednesday"
                            ? {
                                label: "Środa",
                                value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                            }
                            : el.weekDay === "Thursday"
                                ? {
                                    label: "Czwartek",
                                    value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                                }
                                : el.weekDay === "Friday"
                                    ? {
                                        label: "Piątek",
                                        value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                                    }
                                    : el.weekDay === "Saturday"
                                        ? {
                                            label: "Sobota",
                                            value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                                        }
                                        : {
                                            label: "Niedziela",
                                            value: el.open ? `${el.hourFrom}-${el.hourTo}` : "Nieczynne",
                                        }
            )
        );


        const _telephonesArray = [
            data.phone ? {
                label: "Główny",
                value: data?.phone,
                name: "phone"
            } : {
                label: "Główny",
                value: "",
                name: "phone"
            },
            data.phonePayments ? {
                label: "Ogólny",
                value: data?.phonePayments,
                name: "phonePayments",
            } : {
                label: "Ogólny",
                value: "",
                name: "phonePayments",
            },
            data.phoneService ? {
                label: "Serwisowy",
                value: data?.phoneService,
                name: "phoneService",
            } : {
                label: "Serwisowy",
                value: data?.phoneService,
                name: "phoneService",
            },

        ];
        setTelephones(_telephonesArray);


        let _companyArray = [];

        _companyArray.push({
            label: `Rok założenia firmy`,
            value: !data.yearOfEstablishment
                ? ""
                : `${data?.yearOfEstablishment}`,
            name: "yearOfEstablishment",
        });

        _companyArray.push({
            label: `Forma prawna`,
            value: !data.legalForm ? "" : `${data?.legalForm}`,
            name: "legalForm",
        });

        _companyArray.push({
            label: `Opis do małej wizytówki oraz podstrony operatora`,
            value: !data.information ? "" : `${data?.information}`,
            name: "information",
        });

        _companyArray.push({
            label: `Opis firmy do mapy dobra (maks. 450 znaków)`,
            value: !data.companyDifferentiators
                ? ""
                : `${data?.companyDifferentiators}`,
            name: "companyDifferentiators",
        });

        setCompanyInfo([..._companyArray]);

        let _companyDiffArray = [];

        if (
            data?.companyDifferentiatorsMap &&
            !!Object.keys(data?.companyDifferentiatorsMap).length
        ) {
            let index = 1;
            for (const [key, value] of Object.entries(
                data?.companyDifferentiatorsMap
            )) {
                _companyDiffArray.push({
                    label: `Cecha ${index++}`,
                    value: `${value}`,
                    name: `${key}`,
                });
            }
            setcompanyDiffInfo(_companyDiffArray);
        }

        let _bokArray = [];

        if (
            data?.bokZipcode ||
            data?.bokCity ||
            data?.bokStreet ||
            data?.bokHouseFlatNumber
        ) {
            _bokArray.push({
                label: `Adres BOK`,
                value: `${data?.bokZipcode ? data?.bokZipcode : " "} ${data?.bokCity ? data?.bokCity : " "
                } ${data?.bokStreet ? data?.bokStreet : " "} ${data?.bokHouseFlatNumber ? "nr lokalu:" : " "
                } ${data?.bokHouseFlatNumber ? data?.bokHouseFlatNumber : " "}`,
            });
        }
        setBok(_bokArray);

        let _bokInfoArray = [];
        if (data?.bokFloor) {
            _bokArray.push({
                label: `Gdzie się znajduje`,
                value: `${data?.bokFloor}`,
            });
        }
        setBokInfo(_bokInfoArray);

        let _bokCustomerServicesArray = [];
        if (data?.waitingTimeDuringBusinessHours) {
            _bokCustomerServicesArray.push({
                label: `Szacowany czas reakcji na telefon w godzinach pracy`,
                value: `${data?.waitingTimeDuringBusinessHours}`,
            });
        }
        if (data?.waitingTimeOverBusinessHours) {
            _bokCustomerServicesArray.push({
                label: `Szacowany czas reakcji na telefon poza godzinami pracy`,
                value: `${data?.waitingTimeOverBusinessHours}`,
            });
        }

        if (data?.waitingTimeChangeService) {
            _bokCustomerServicesArray.push({
                label: `Szacowany czas oczekiwania na realizację podłączenia`,
                value: `${data?.waitingTimeChangeService}`,
            });
        }

        if (data?.waitingTimeFixService) {
            _bokCustomerServicesArray.push({
                label: `Szacowany czas oczekiwania usunięcia usterki`,
                value: `${data?.waitingTimeFixService}`,
            });
        }
        setBokSvcCust(_bokCustomerServicesArray);

    }

    const fetchProfilesData = () => {
        if (profile.getEpid()) {
            axios
                .get(`${getUrl()}/api/v1/profile/epid/${profile.getEpid()}`, {
                    headers: {Authorization: `Bearer ${token}`},
                })
                .then((res) => {
                    const data = res.data;
                    setProfileVariables(data);

                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.status === 401 || err.response.status === 500 || err.response.status === 403) {
                            alert('Twoja sesja wygasła, za chwile zostaniesz wylogowany z systemu i przekierowany na stronę główną. ' +
                                'Aby ponownie skorzystać z systemu musisz się ponownie zalogować ');
                            logout({
                                logoutParams: {returnTo: `${window.location.origin}`},
                            });
                        }
                    } else {
                        console.log(err);
                    }
                });
        }
    };

    useEffect(() => {
        fetchProfilesData();
    }, [profile]);

    const RangesWithEditableLoader = withEditableCompanyInfo(
        InputListCard,
        "Edytuj zasięgi (tylko liczby)",
        null,
        data.id,
        [
            {
                header: "Szacowana Liczba Mieszkań",
                list: [
                    {
                        label: "Liczba mieszkań",
                        value: data?.totalHp,
                        name: "totalHp",
                        type: "number",
                    },
                    {
                        label: "Wszyscy abonenci",
                        value: data?.totalCustomers,
                        name: "totalCustomers",
                        type: "number",
                    },
                    {
                        label: "Światłowód",
                        value: data?.totalCustomersFiber,
                        name: "totalCustomersFiber",
                        type: "number",
                    },
                    {
                        label: "Ethernet",
                        value: data?.totalCustomersEthernet,
                        name: "totalCustomersEthernet",
                        type: "number",
                    },
                    {
                        label: "Wifi/radio",
                        value: data.totalCustomersWifi,
                        name: "totalCustomersWifi",
                        type: "number",
                    },
                    {
                        label: "Inni w zasięgu",
                        value: data.totalCustomersOther,
                        name: "totalCustomersOther",
                        type: "number",
                    },
                ],
            },
        ],
        data.companyDifferentiatorsMap,
        null,
        `${getUrl()}${data?.photo}` ? `${getUrl()}${data?.photo}` : placeholder,
        `${token}`,
        `${getUrl()}/api/v1/profile`,
        profile.getEpid(),
        handleCloseEditRangesNew,
        handleSavedEditRangesNew,
        //readProfile,
        fetchProfilesData,
        setopenInProgress,
        editRangesNewRef
    );

    const ServicesWithEditableLoader = withEditableServices(
        SwitchListCard,
        data.id,
        {
            "Internet światłowodowy": data.fiberInternetServices
                ? data.fiberInternetServices
                : false,

            "Internet radiowy": data.wirelessInternet ? data.wirelessInternet : false,

            "Internet mobilny": data.wiredInternetServices
                ? data.wiredInternetServices
                : false,

            // "Pakiety TV": data.tvPackagesFlag
            //   ? data.tvPackagesFlag
            //   : false,

            Telewizja: data.tvServices ? data.tvServices : false,

            Telefonia: data.telephonyServices ? data.telephonyServices : false,

            "Telefonia mobilna": data.mobileServicesFlag ? data.mobileServicesFlag : false,

            Inne: data.servicesOther ? data.servicesOther : false,
        },
        otherServicesList,
        mobileInternetServicesList,
        fiberInternetServicesList,
        wirelessInternetServicesList,
        tvServicesList,
        telephonyServicesList,
        mobileTelephonyServicesList,
        tvPacketsServicesList,
        [...data.metadata ? data?.metadata.filter(el => el.category === "Usługi").map(el => ({
            koalaTel: el.booleanValue2, kameleonTV: el.booleanValue1, rowId: el.rowId
        })) : ""],
        `${token}`,
        //`${getUrl()}/api/v1/profile`,
        `${getUrl()}/api/v1`,
        profile.getEpid(),
        handleCloseEditServices,
        handleSavedEditServices,
        fetchProfilesData,
        editServicesRef
    );

    const ClientTypesWithEditableLoader = withEditableClientTypes(
        SwitchListCard,
        data.id,
        [
            {
                "Klient indywidualny": !data.b2c ? "" : data.b2c,
            },
            {
                "Klient biznesowy": !data.b2b ? "" : data.b2b,
            },
            {
                "Instytucje rządowe": !data.institutions ? "" : data.institutions,
            },
        ],
        `${token}`,
        `${getUrl()}/api/v1/profile`,
        profile.getE,
        handleCloseClientTypes,
        handleSavedEditClientTypes,
        //readProfile
        fetchProfilesData,
        closeClientTypesRef
    );

    const MeetCompanyWithEditableLoader = withEditableMeetCompany(
        "Edytuj informacje",
        data.id,
        `${token}`,
        `${getUrl()}/api/v1`,
        profile.getEpid(),
        [...data.metadata ? data?.metadata.filter(el => el.category === "Ciekawostki").map(el => ({
            header: el.key,
            text: el.stringValue1,
            rowId: el.rowId
        })) : ""],
        [...data.metadata ? data?.metadata.filter(el => el.category === "Poznaj firme").map(el => ({
            header: el.key,
            text: el.stringValue1,
            rowId: el.rowId
        })) : ""],
        [{
            header: "SOCIAL MEDIA",
            list: [
                {
                    label: "Facebook",
                    value: data?.socialMediaLinks ? `${data?.socialMediaLinks}` : "",
                    name: "socialMediaLinks",
                },
                {label: `www`, value: data?.website ? `${data?.website}` : "", name: "website"},
                {
                    label: `Email`,
                    value: data?.contactEmail ? `${data?.contactEmail}` : "",
                    name: "contactEmail",
                },
            ],
        },],
        [...data.metadata ? data?.metadata.filter(el => el.category === "Kanały socialmedia").map(el => ({
            header: el.key,
            text: el.stringValue1,
            rowId: el.rowId
        })) : ""],
        [...data.metadata ? data?.metadata.filter(el => el.category === "Adresy biur").map(el => ({
            header: el.key,
            text: el.stringValue1,
            rowId: el.rowId
        })) : ""],
        [...data.metadata ? data?.metadata.filter(el => el.category === "Artykuły SEO").map(el => ({
            header: el.key,
            text: el.stringValue1,
            rowId: el.rowId
        })) : ""],
        handleCloseEditMeetCompany,
        handleSavedEditMeetCompany,
        fetchProfilesData,
        setopenInProgress,
        editMeetCompanyRef
    );

    const CompanyInfoWithEditableLoader = withEditableCompanyInfo(
        InputListCard,
        "Edytuj o firmie",
        "Zdjęcia firmy/pracownikow",
        data.id,
        [
            {
                header: null,
                list: [...companyInfo],
            }


        ],
        data.companyDifferentiatorsMap,
        null,
        `${getUrl()}${data?.photo}` ? `${getUrl()}${data?.photo}` : placeholder,
        `${token}`,
        `${getUrl()}/api/v1/profile`,
        profile.getEpid(),
        handleCloseEditCompanyInfo,
        handleSavedEditCompanyInfo,
        fetchProfilesData,
        setopenInProgress,
        editCompanyInfoRef
    );

    const CompanyGeneralInfoWithEditableLoader = withEditableCompanyInfo(
        InputListCard,
        "Edytuj podstawowe dane o firmie",
        "Logo",
        data.id,
        [
            {
                list: [
                    {label: "Numer EPID", value: `${profile.getEpid()}`, disabled: true},
                    {
                        label: `Nazwa Firmy`,
                        value: data.companyName ? `${data.companyName}` : "",
                        disabled: true,
                    },
                    {
                        label: `Nazwa SEO`,
                        value: data.seoLink ? `${data.seoLink}` : "",
                        disabled: true,
                    },
                ],
            },
            {
                header: "Adres",
                list: [
                    {
                        label: "Miasto",
                        value: data?.companyAddressCity,
                        name: "companyAddressCity",
                    },
                    {
                        label: "Ulica",
                        value: data?.companyAddressStreet,
                        name: "companyAddressStreet",
                    },
                    {
                        label: "Numer lokalu",
                        value: data?.companyAddressBuildNumber,
                        name: "companyAddressBuildNumber",
                        type: "number",
                    },
                ],
            },
            {
                header: "NUMERY TEL.",
                list: telephones,
            },

        ],
        null,
        data.workingHours,
        `${getUrl()}${data?.companyLogoUrl}`,
        `${token}`,
        `${getUrl()}/api/v1/profile`,
        profile.getEpid(),
        handleCloseEditCompanyGeneralInfo,
        handleSavedEditCompanyGeneralInfo,
        fetchProfilesData,
        setopenInProgress,
        companyGeneralInfoRef
    );

    const VariousInfoWithEditableLoader = withEditableInfo(
        InputListCard,
        "Edytuj informacje",
        null,
        data.id,
        [
            {
                header: "Adres BOK",
                list: [
                    {
                        label: "Miasto",

                        value: data?.bokCity ? data?.bokCity : " ",

                        name: "bokCity",
                    },
                    {
                        label: "Ulica",

                        value: data?.bokStreet,

                        name: "bokStreet",
                    },
                    {
                        label: "Numer lokalu",

                        value: data?.bokHouseFlatNumber,
                        name: "bokHouseFlatNumber",
                    },
                ],
            },
        ],
        null,
        null, //data.workingHours,
        [
            {
                header: "Informacje o BOK/eBOK",
                list: [
                    {
                        label: "Gdzie się znajduje",
                        value: data?.bokFloor,
                        name: "bokFloor",
                    },
                    {
                        label: "Co można załatwić",
                        value: data.ebokServicesList && data.ebokServicesList[0],
                        name: "ebokServicesList",
                    },
                ],
            },
        ],
        {
            "Czy jest miejsce na rower": data.placeForBike
                ? data.placeForBike
                : false,
            "Czy jest miejsce na pieska": data.placeForDog ? data.placeForDog : false,
            "Czy jest poczekalnia": data.waitingRoom ? data.waitingRoom : false,
            "Czy jest klimatyzacja": data.airConditioning
                ? data.airConditioning
                : false,
            "Czy oferowane są napoje": data.drinks ? data.drinks : false,
            "Czy jest obsługa w języku obcym": data.foreignLanguage
                ? data.foreignLanguage
                : false,
        },
        [
            {
                list: [
                    {
                        label: "Odległość od komunikacji miejsckiej",
                        value: data.distanceToBus ? data.distanceToBus : "np. 1 km",
                        name: "distanceToBus",
                    },
                ],
            },
        ],
        {
            "Czy jest możliwy kontakt telefoniczny po godzinach pracy biura":
                data.supportAfterHours ? data.supportAfterHours : false,
            "Czy można zgłaszać usterki": data.supportAvailable
                ? data.supportAvailable
                : false,
            "Czy można zamówić usługi": data.ordersAvailable
                ? data.ordersAvailable
                : false,
        },
        [
            {
                header: "Obsługa klienta",
                list: [
                    {
                        label: "Szacowany czas na odebranie telefonu w godzinach biura",
                        value: data.waitingTimeDuringBusinessHours
                            ? data.waitingTimeDuringBusinessHours
                            : "np. 3 min",
                        name: "waitingTimeDuringBusinessHours",
                    },
                    {
                        label:
                            "Szacowany czas na odebranie telefonu poza godzinami pracy biura",
                        value: data.waitingTimeOverBusinessHours
                            ? data.waitingTimeOverBusinessHours
                            : "np. 3 min",
                        name: "waitingTimeOverBusinessHours",
                    },
                    {
                        label:
                            "Szacowany czas oczekiwania na realizację podłączenia usługi",
                        value: data.waitingTimeInstallationService
                            ? data.waitingTimeInstallationService
                            : "np. 3 min",
                        name: "waitingTimeInstallationService",
                    },
                    {
                        label: "Szacowany czas oczekiwania na realizację usług dodatkowych",
                        value: data.waitingTimeChangeService
                            ? data.waitingTimeChangeService
                            : "np. 3 min",
                        name: "waitingTimeChangeService",
                    },
                    {
                        label: "Szacowany czas oczekiwania usunięcie usterki",
                        value: data.waitingTimeFixService
                            ? data.waitingTimeFixService
                            : "np. 3 min",
                        name: "waitingTimeFixService",
                    },
                ],
            },
        ],
        null,
        `${token}`,
        `${getUrl()}/api/v1/profile`,
        profile.getEpid(),
        handleCloseEditVariousInfo,
        handleSavedEditVariousInfo,
        fetchProfilesData,
        setopenInProgress,
        closeEditVariousInfoRef
    );

    const handleFileDownloadAndOpen = async () => {
        try {
            const response = await axios.get(`${getUrl()}/api/v1/provider/download-help-file`, {
                responseType: "blob"
            });

            const blobObj = new Blob([response.data], {type: "application/pdf"});

            const url = window.URL.createObjectURL(blobObj);

            window.open(url, "_blank");

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Błąd pobierania pliku:", error);
            alert("Błąd podczas pobierania pliku. Spróbuj ponownie.");
        }
    };

    useEffect(() => {
        if (menuIx === CompanyMenu.HELP) {
            handleFileDownloadAndOpen();
        } else {
            if (profilerefs && profilerefs[menuIx]?.current) {
                profilerefs[menuIx].current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        }
    }, [menuIx])

    const drawRangeSummary = () => {
        return (
            <Box
                sx={{
                    bgcolor: 'var(--color-blue-shadow)',
                    // bgcolor: 'var(--color-primary-green)',

                    mt: "24px",
                    display: "flex",
                    justifyContent: "center",
                    "& > *": {
                        maxWidth: "800px",
                        minWidth: "800px"
                    }
                }}
            >
                <CompanyProfileCard
                    cardName="Zasięgi"
                    fileDownloadBox={
                        <FileDownloadBox
                            clickHandler={downloadBox}
                            auth={{
                                epid: profile.getEpid(),
                                token: token
                            }}
                            fileName="Plik_z_wgranymi_zasiegami.csv"
                            fileUrl="http://urldopliku.pl"
                            wiredInternetServices
                            header="Wgrane Zasięgi"
                        />
                    }
                    fileDownloadBoxHeader="Wgrane zasięgi"
                    infoList={[
                        {
                            header: "Szacowana liczba mieszkań",

                            list: [
                                {label: "liczba mieszkań", value: data?.totalHp},
                                {label: "Wszyscy abonenci", value: data?.totalCustomers},
                                {
                                    label: `światłowód`,
                                    value: `${data?.totalCustomersFiber}`,
                                },
                                {
                                    label: `Ethernet`,
                                    value: `${data?.totalCustomersEthernet}`,
                                },
                                {label: `Wifi/radio`, value: `${data?.totalCustomersWifi}`},
                                {
                                    label: `Inni w zasięgu`,
                                    value: `${data?.totalCustomersOther}`,
                                },
                            ],
                        },
                    ]}
                    buttonHandler={() => {
                        setEditRangesNew(true);
                    }}
                >
                    <ConnectWithoutContactIcon
                        sx={{
                            color: "#fff",
                        }}
                    />
                </CompanyProfileCard>
            </Box>

        )
    }

    const drawBasicDataSummary = () => {
        return (

            <Box
                sx={{

                    mt: "24px",
                    display: "flex",
                    justifyContent: "center",
                    "& > *": {
                        maxWidth: "800px",
                        minWidth: "800px"
                    }
                }}
            >
                <CompanyProfileCard
                    cardName="Podstawowe dane"
                    buttonHandler={() => {
                        setEditCompanyGeneralInfo(true);
                    }}
                    infoList={[
                        {
                            header: "LOGO",
                            imageUrl: `${getUrl()}${data?.companyLogoUrl}`,
                            list: [
                                {label: "Numer EPID", value: `${profile.getEpid()}`},
                                {label: `Nazwa Firmy`, value: data?.companyName},
                                {label: `Nazwa SEO`, value: data?.seoLink},
                                {
                                    label: `Adres`,
                                    value: `
                                ${data?.bokCity
                                        ? data?.bokCity
                                        : data?.companyAddressCity
                                            ? data?.companyAddressCity
                                            : " "
                                    }
                                ${data?.bokStreet
                                        ? data?.bokStreet
                                        : data?.companyAddressStreet
                                            ? data?.companyAddressStreet
                                            : " "
                                    } 
                                ${data?.bokHouseFlatNumber
                                        ? data?.bokHouseFlatNumber
                                        : data?.companyAddressBuildNumber
                                            ? data?.companyAddressBuildNumber
                                            : " "
                                    }`,
                                },
                            ],
                        },
                        {
                            header: "NUMERY TEL.",
                            list: telephones,
                        },

                        {
                            header: "Godziny otwarcia",
                            list: [...workingHoursState],
                        },
                    ]}
                >
                    <DescriptionOutlinedIcon
                        sx={{
                            color: "#fff",
                        }}
                    />
                </CompanyProfileCard>
            </Box>

        )
    }

    const drawServiceSummary = () => {
        return (

            <Box
                sx={{
                    mt: "24px",
                    display: "flex",
                    justifyContent: "center",
                    "& > *": {
                        maxWidth: "800px",
                        minWidth: "800px"
                    }

                }}
            >
                <CompanyProfileCard
                    cardName="Usługi"
                    buttonHandler={handleOpenEditServices}
                    infoList={[
                        {
                            header: "Rodzaj świadczonych usług",
                            list: [
                                {
                                    label: `Internet światłodowy`,
                                    value: `${data?.fiberInternetServices ? "TAK" : "NIE"}`,
                                },
                                {
                                    label: `Internet radiowy`,
                                    value: `${data?.wirelessInternet ? "TAK" : "NIE"}`,
                                },
                                {
                                    label: "Internet mobilny",
                                    value: `${data?.wiredInternetServices ? "TAK" : "NIE"}`,
                                },
                                {
                                    label: "Telewizja",
                                    value: `${data?.tvServices ? "TAK" : "NIE"}`,
                                },
                                // {
                                //   label: "Pakiety TV",
                                //   value: `${data?.tvPackagesFlag ? "TAK" : "NIE"}`,
                                // },
                                {
                                    label: "Telefon domowy",
                                    value: `${data?.telephonyServices ? "TAK" : "NIE"}`,
                                },
                                {
                                    label: "Telefon komórkowy",
                                    value: `${data?.mobileServicesFlag ? "TAK" : "NIE"}`,
                                },
                                {
                                    label: "Inne",
                                    value: `${otherServicesList?.length > 0 ? "TAK" : "NIE"
                                    }`,
                                },
                            ],
                        },
                    ]}
                >
                    <HomeRepairServiceOutlinedIcon
                        sx={{
                            color: "#fff",
                        }}
                    />
                </CompanyProfileCard>
            </Box>
        )
    }

    const drawCompanyInfoSummary = () => {
        return (
            <Box
                sx={{
                    mt: "24px",
                    display: "flex",
                    justifyContent: "center",
                    "& > *": {
                        maxWidth: "800px",
                        minWidth: "800px"
                    }

                }}
            >
                <CompanyProfileCard
                    cardName="O firmie"
                    buttonHandler={() => {
                        setEditCompanyInfo(true);
                    }}
                    infoList={[
                        {
                            header: "Zdjęcie wyróżnik firmy",
                            imageUrl: `${getUrl()}${data?.photo}`
                                ? `${getUrl()}${data?.photo}`
                                : placeholder,
                            list: [...companyInfo],
                        },

                    ]}
                >
                    <ApartmentOutlinedIcon
                        sx={{
                            color: "#fff",
                        }}
                    />
                </CompanyProfileCard>
            </Box>

        )
    }

    const drawMeetCompanySummary = () => {
        return (

            <Box
                sx={{
                    bgcolor: 'var(--color-blue-shadow)',

                    mt: "24px",
                    display: "flex",
                    justifyContent: "center",
                    "& > *": {
                        maxWidth: "800px",
                        minWidth: "800px"
                    }

                }}
            >
                <CompanyProfileCard
                    cardName="Informacje"
                    buttonHandler={() => {
                        setEditMeetCompany(true);
                    }}
                    infoList={[
                        {
                            header: "SOCIAL MEDIA",
                            list: [
                                {
                                    label: "Facebook",
                                    value: data?.socialTiktok
                                        ? data?.socialTiktok
                                        : data?.socialMediaLinks
                                            ? data?.socialMediaLinks
                                            : " "
                                    ,
                                },
                                {label: `www`, value: data?.website},
                                {
                                    label: `Email`,
                                    value: `${data?.emailCustomerCare
                                        ? data?.emailCustomerCare
                                        : data?.contactEmail
                                            ? data?.contactEmail
                                            : data?.emailMarketing
                                                ? data?.emailMarketing
                                                : " "
                                    }${data?.emailMarketing ? ", " : ""}${data?.emailMarketing ? data?.emailMarketing : " "
                                    }`,
                                },
                            ],
                        },
                        {
                            header: "Poznaj firmę od podszewki",

                            list: [...data.metadata ? data?.metadata.filter(el => el.category === "Poznaj firme").map(el => ({
                                label: el.key,
                                key: el.stringValue1
                            })) : ""]
                        },
                        {
                            header: "Ciekawostki",

                            list: [...data.metadata ? data?.metadata.filter(el => el.category === "Ciekawostki").map(el => ({
                                label: el.key,
                                key: el.stringValue1
                            })) : ""]
                        },

                    ]}
                >
                    <ApartmentOutlinedIcon
                        sx={{
                            color: "#fff",
                        }}
                    />
                </CompanyProfileCard>
            </Box>

        )
    }

    const drawOperationalContactSummary = () => {
        return (
            <CompanyProfileApla
                profile={profile}
                token={token}
                menuIx={menuIx}
                cardName="Kontakty operacyjne"
                infoList={null}
            />
        )
    }

    const drawRangeForm = () => {
        return (
            <Modal
                open={editRangesNew}
                onClose={handleCloseEditRangesNew}
                onKeyDown={onKeyDownEditRangesNew}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",

                    }}
                >
                    <RangesWithEditableLoader/>
                </Box>
            </Modal>

        )
    }

    const drawBasicDataForm = () => {
        return (
            <Modal
                open={editCompanyGeneralInfo}
                onClose={handleCloseEditCompanyGeneralInfo}
                onKeyDown={onKeyDownEditCompanyGeneralInfo}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",

                    }}
                >
                    <CompanyGeneralInfoWithEditableLoader/>
                </Box>
            </Modal>
        )
    }

    const drawServiceForm = () => {
        return (
            <Modal
                open={editServices}
                onClose={handleCloseEditServices}
                onKeyDown={onKeyDownEditServices}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",

                    }}
                >
                    <ServicesWithEditableLoader/>
                </Box>
            </Modal>
        )
    }

    const drawCompanyInfoForm = () => {
        return (
            <Modal
                open={editCompanyInfo}
                onClose={handleCloseEditCompanyInfo}
                onKeyDown={onKeyDownEditCompanyInfo}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",
                    }}

                >
                    <CompanyInfoWithEditableLoader/>
                </Box>
            </Modal>
        )
    }

    const drawMeetCompanyForm = () => {
        return (
            <Modal
                open={editMeetCompany}
                onClose={handleCloseEditMeetCompany}
                onKeyDown={onKeyDownEditMeetCompany}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        bgcolor: 'var(--color-blue-shadow)',
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",

                    }}
                >
                    <MeetCompanyWithEditableLoader sx={{bgcolor: 'var(--color-blue-shadow)'}}/>
                </Box>
            </Modal>
        )
    }

    const drawClientTypeForm = () => {
        return (
            <Modal
                open={editClientTypes}
                onClose={handleCloseClientTypes}
                onKeyDown={onKeyDownClientTypes}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",

                    }}
                >
                    <ClientTypesWithEditableLoader sx={{bgcolor: 'var(--color-blue-shadow)'}}/>
                </Box>
            </Modal>
        )
    }

    const drawVariousInfoForm = () => {
        return (
            <Modal
                open={editVariousInfo}
                onClose={handleCloseEditVariousInfo}
                onKeyDown={onKeyDownEditVariousInfo}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="apla"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        borderRadius: "var(--box-radius)",
                        border: "var(--box-border)",
                        boxShadow: "var(--box-shadow)",
                    }}
                >
                    <VariousInfoWithEditableLoader/>
                </Box>
            </Modal>
        )
    }

    return (
        <>
            <Box
                id="list-container-test"
                className={clsx(css.companyProfileCardsList)}
                sx={{
                    // bgcolor: "#fafafc",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    overflow: "auto",
                    width: "100%",
                }}
            >
                {CompanyMenu.RANGE_AREA === menuIx && drawRangeSummary()}

                {CompanyMenu.BASIC_DATA === menuIx && drawBasicDataSummary()}

                {CompanyMenu.SERVICES === menuIx && drawServiceSummary()}

                {CompanyMenu.ABOUT_COMPANY === menuIx && drawCompanyInfoSummary()}

                {CompanyMenu.INFORMATION === menuIx && drawMeetCompanySummary()}

                {CompanyMenu.OPERATIONAL_CONTACTS === menuIx && drawOperationalContactSummary()}

                {drawRangeForm()}

                {drawBasicDataForm()}

                {drawServiceForm()}

                {drawCompanyInfoForm()}

                {drawMeetCompanyForm()}

                {drawClientTypeForm()}

                {drawVariousInfoForm()}

            </Box>
        </>
    );
};
export default CompanyProfileCardsList
